(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/prescript.js');

'use strict';

svs.lotto = svs.lotto || {};
svs.lotto.router = svs.lotto.router || {};
svs.lotto.views = svs.lotto.views || {};
svs.lotto.components = svs.lotto.components || {};
svs.lotto.logger = svs.lotto.logger || new svs.core.log.Logger('module:lotto');

 })(window);